import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ConfirmationService } from 'primeng/api'
import { LoggerService } from '@danangelus/ngx-app-core'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { ToggleSwitchModule } from 'primeng/toggleswitch'
import { SsoService } from '../../../../core/services/sso.service'
import { MessageModule } from 'primeng/message'

const log = LoggerService.get('DCToggleComponent')

/**
 * Component to toggle access to the Gateway and associated applications
 */
@Component({
  selector: 'dcs-toggle',
  standalone: true,
    imports: [
        FormsModule,
        ConfirmDialogModule,
        MessageModule,
        ReactiveFormsModule,
        ToggleSwitchModule,
    ],
  providers: [
      ConfirmationService,
  ],
  templateUrl: './dcs-toggle.component.html',
  styleUrl: './dcs-toggle.component.sass',
  encapsulation: ViewEncapsulation.None
})
export class DCSToggleComponent implements OnInit{

    ssoService = inject(SsoService)
    confirmationService = inject(ConfirmationService)

    isLockedOut: boolean | undefined
    messageType = ''

    async ngOnInit() {
        this.isLockedOut = await this.ssoService.getDcsStatus()
    }

    async toggleDCS() {
        if (!this.isLockedOut) {
            this.confirmationService.confirm({
                // ToDo :: Internationalisation
                message: 'Are you sure you want to disable access to the DCS?',
                header: 'Toggle DCS',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                    log.info('toggleDCS','Switching off DCS Access')
                    await this.updateDCS()
                },
                reject: () => {
                    this.messageType = 'DCS_NOT_DISABLED'
                }
            })
        } else {
            log.info('toggleDCS', 'Switching on DCS Access')
            await this.updateDCS()
        }
    }
    async updateDCS() {
        try {
            this.isLockedOut = !this.isLockedOut
            await this.ssoService.toggleDCS(this.isLockedOut)
            this.messageType = this.isLockedOut ? 'DCS_DISABLED' : 'DCS_ENABLED'
        } catch (e) {
            log.error(`Error switching DCS Status: ${e}`)
            this.messageType = 'INTERNAL_SERVER'
        }
    }
}
